const TZ = "America/Santiago";

export const fmtDateTime = (v) =>
  v ? new Date(v.endsWith?.("Z") || v.includes?.("+") ? v : v + "Z").toLocaleString("es-CL", { timeZone: TZ, dateStyle: "short", timeStyle: "short" }) : "—";

export const fmtRelative = (v) => {
  if (!v) return "—";
  const d = new Date(v.endsWith?.("Z") || v.includes?.("+") ? v : v + "Z");
  const mins = Math.round((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return "ahora";
  if (mins < 60) return `hace ${mins} min`;
  if (mins < 1440) return `hace ${Math.round(mins / 60)} h`;
  return fmtDateTime(v);
};

export const SCOPE_LABELS = { ot: "Órdenes de Trabajo", warehouse: "Bodegas / Sub-bodegas", area: "Áreas" };

export const clp = (v) => (v === null || v === undefined ? "—" : "$ " + Math.round(v).toLocaleString("es-CL"));

export const OPP_STATUS = {
  borrador: { label: "Borrador", tone: "inactivo" },
  cotizada: { label: "Cotizada", tone: "info" },
  en_seguimiento: { label: "En seguimiento", tone: "pendiente" },
  adjudicada: { label: "Adjudicada", tone: "activo" },
  no_adjudicada: { label: "No adjudicada", tone: "bloqueado" },
  cancelada: { label: "Cancelada", tone: "inactivo" },
};

export const OT_TONE = { PLANIFICADA: "info", "EN_EJECUCIÓN": "activo", SUSPENDIDA: "pendiente", CERRADA: "inactivo", CANCELADA: "bloqueado" };

export const fmtDate = (v) => (v ? v.split("-").reverse().join("-") : "—");

export const fmtTime = (v) =>
  v ? new Date(v.endsWith?.("Z") || v.includes?.("+") ? v : v + "Z").toLocaleTimeString("es-CL", { timeZone: TZ, hour: "2-digit", minute: "2-digit" }) : "—";
